module.exports = __webpack_public_path__ + "img/info.e3c26e02.svg";